/* eslint-disable no-nested-ternary */
import { Button, Flex, theme, Typography } from '@styles';
import { ReactComponent as DropdownDownIcon } from '@svgs/chevron-down.svg';
import { ReactComponent as DropdownUpIcon } from '@svgs/chevron-up.svg';
import { arrayOf, bool, func, number, object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';

const ProgressDropdown = ({
  currentActivityId,
  isCurrentLesson,
  isLessonPassed,
  items,
  largeFont,
  mainId,
  onActivityPress,
  onPress,
  onPressEnd,
  title,
}) => {
  const { i18n } = useTranslation();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const hasItems = items?.length > 0;

  useEffect(() => {
    setIsDropdownOpen(isCurrentLesson);
  }, [isCurrentLesson]);

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  return (
    <Flex flexDirection="column" gap={8} pl={12}>
      <Flex alignItems="center" gap={10} position="relative">
        <Button
          disabled={!hasItems}
          // height={largeFont ? 50 : 25}
          height={largeFont ? 50 : 'fit-content'}
          onClick={toggleDropdown}
          opacity={hasItems ? 1 : 0}
          p={0}
          variant="textButton"
        >
          {isDropdownOpen ? (
            <Icon
              color={theme.colors.white[100]}
              height={20}
              SVG={DropdownUpIcon}
              width={20}
            />
          ) : (
            <Icon
              color={theme.colors.white[100]}
              height={20}
              SVG={DropdownDownIcon}
              width={20}
            />
          )}
        </Button>
        <Button
          // height={25}
          height="fit-content"
          onClick={() => {
            onPress();
            onPressEnd?.();
          }}
          p={0}
          variant="textButton"
        >
          <Typography
            color={
              isLessonPassed ? theme.colors.white[60] : theme.colors.white[100]
            }
            textAlign="left"
            variant={
              largeFont ? 'MS-semibold-s18-lh19' : 'MS-semibold-s14-lh22'
            }
          >
            {title}
          </Typography>
        </Button>
      </Flex>
      {hasItems && isDropdownOpen && (
        <Flex flexDirection="column" gap={8} pl={24}>
          {items?.map((item) => (
            <Button
              height={22}
              justifyContent="flex-start"
              onClick={() => {
                onActivityPress?.({
                  activityId: item?.id,
                  lessonId: mainId,
                })();
                onPressEnd?.();
              }}
              p={0}
              variant="textButton"
            >
              <Flex gap={16}>
                <Flex
                  bg={
                    item.id === currentActivityId
                      ? theme.colors.schoolBusYellow[100]
                      : item.is_completed
                        ? theme.colors.white[30]
                        : theme.colors.white[100]
                  }
                  borderRadius={2}
                  grow={0}
                  width={2}
                />
                <Typography
                  color={
                    isLessonPassed
                      ? theme.colors.white[60]
                      : theme.colors.white[100]
                  }
                  variant="MS-regular-s14-lh22"
                >
                  {i18n.t(`ActivityTypes.${item?.content_type}`)}
                </Typography>
              </Flex>
            </Button>
          ))}
        </Flex>
      )}
    </Flex>
  );
};

ProgressDropdown.propTypes = {
  currentActivityId: number.isRequired,
  isCurrentLesson: bool.isRequired,
  isLessonPassed: bool.isRequired,
  items: arrayOf(object),
  largeFont: bool,
  mainId: number.isRequired,
  onActivityPress: func.isRequired,
  onPress: func.isRequired,
  onPressEnd: func,
  title: string.isRequired,
};

ProgressDropdown.defaultProps = {
  items: [],
  largeFont: false,
  onPressEnd: null,
};

export default ProgressDropdown;
